import { atom } from "jotai";
import { atomWithMutation } from "jotai-tanstack-query";
import { submitReport } from "@/modules/plus/reports/plus.reports.api";
import type { AtomContainer } from "@/state";

export class ReportsAtoms {
  // biome-ignore lint/correctness/noUnusedPrivateClassMembers: held for future cross-atom wiring
  constructor(private readonly atoms: AtomContainer) {}

  // Whether the report dialog is currently open. Kept here (not in the
  // Toolbar) so other surfaces can open the dialog with prefilled context
  // (e.g., a "Report this" button on a decoded result).
  public isOpen = atom<boolean>(false);

  // Prefilled context attached to the next-submitted report (e.g., the
  // currently-decoded code). Reset on close.
  public draftContext = atom<{ code?: string } | null>(null);

  public open = atom(null, (_get, set, ctx?: { code?: string }) => {
    set(this.draftContext, ctx ?? null);
    set(this.isOpen, true);
  });

  public close = atom(null, (_get, set) => {
    set(this.isOpen, false);
    set(this.draftContext, null);
  });

  public submit = atomWithMutation((get) => ({
    // The server stamps the reporter from the session — no reporter here.
    mutationFn: async (body: string) => {
      const ctx = get(this.draftContext);
      await submitReport({
        body,
        context: {
          code: ctx?.code,
          url: window.location.pathname,
        },
      });
    },
  }));
}
